<template>
  <div class="page-wrapper">
    <alert-window ref="alertWindow"></alert-window>
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">Настройки</div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="form" v-if="workSettings.length === 6">
                      <div class="fieldset">
                        <label class="fieldset-title">Настройки уведомления, час.
                          <div class="help">?
                            <span class="text">Время (в часах), за которое нужное присылать Диспетчеру уведомление о том, что не внесена предоплата (для заявки с безналичным способом оплаты), или что не все ребочие для заявки назначены.</span>
                          </div>
                        </label>
                        <fieldset><input type="number" v-model="workSettings[0].value" v-mask="'######'"></fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Надбавка «Ночного тарифа», руб.
                          <div class="help">?
                            <span class="text">Время начала действия тарифа – 21.00, время окончания действия тарифа – 07.00.</span>
                          </div>
                        </label>
                        <fieldset><input type="number" v-model="workSettings[1].value" v-mask="'######'"></fieldset>

                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Статус «Суперпостоянный клиент», руб.
                          <div class="help">?
                            <span class="text">Сумма заказов, по достижении которой клиент получает статус «Суперпостоянный клиент».</span>
                          </div>
                        </label>
                        <fieldset><input type="number" v-model="workSettings[2].value" v-mask="'######'"></fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Минимальный баланс для заявок, руб.
                          <div class="help">?
                            <span class="text">Поле для указания минимального баланса рабочего для заявок с типом оплаты «наличные», значение в поле может быть как положительным, так и отрицательным.</span>
                          </div>
                        </label>
                        <fieldset><input type="number" v-model="workSettings[3].value"></fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Надбавка для бригадира за час, руб.
                          <div class="help">?
                            <span class="text">Сумма дополнительного начисления для бригадира заявки за час.</span>
                          </div>
                        </label>
                        <fieldset><input type="number" v-model="workSettings[4].value" v-mask="'######'"></fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Сумма залога, руб.
                          <div class="help">?
                            <span class="text">Залоговая сумма для сотрудников.</span>
                          </div>
                        </label>
                        <fieldset><input type="number" v-model="workSettings[5].value" v-mask="'######'"></fieldset>
                      </div>
                      <div class="buttons">
                        <button type="button" class="save-button" @click="save">Сохранить</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import AlertWindow from '@/components/AlertWindow.vue'
    import api from '@/api'
    import {mask} from 'vue-the-mask'

    export default {
  name: 'Settings',
  components: {
    AlertWindow,
    MenuDispatcher,
    HeaderDispatcher
  },

  directives: {
    mask
  },

  data () {
    return {
      workSettings: []
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')
    api
      .getAllWorkSettings()
      .then(response => this.workSettings = response)
  },

  methods: {
    save () {
      if (this.$store.getters.waitingApiRequestsCount != 0) { return }

      api
        .saveWorkSettings({
          settings: this.workSettings
        })
        .then(response =>
          this.$refs.alertWindow.show('Уведомление', response.data.message))
        .catch(response =>
          this.$refs.alertWindow.show('Ошибка сохранения', response)
        )
    }
  }
}
</script>
